import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/rewards/")({
  beforeLoad: () => {
    throw redirect({
      to: "/rewards/positions",
    });
  },
});
